/// Types
import { useState } from 'react';
import { useSelector } from 'react-redux';
/// Slices
import {
  moveReservationsToTrash,
  movedToTrashResponseSelector,
} from 'slices/reservationTemplate.slice';
import { useAppDispatch } from 'slices/store';
import type { TReservationTemplate } from '@timeedit/types/lib/types';
import { Button } from '@timeedit/ui-components/antd';

type PropsMoveToTrash = {
  template: TReservationTemplate;
};

const MoveReservationsToTrash = ({ template }: PropsMoveToTrash) => {
  const dispatch = useAppDispatch();
  const movedToTrashResponse = useSelector(movedToTrashResponseSelector);

  const [moveToTrashDone, setMoveToTrashDone] = useState(false);

  return (
    <div>
      <Button
        size="small"
        type="default"
        onClick={() => {
          dispatch(moveReservationsToTrash(template));
          setMoveToTrashDone(true);
        }}
      >
        Validate reservations and move to trash
      </Button>
      <p style={{ fontSize: '12px' }}>(If validation fails, move to trash)</p>
      {moveToTrashDone && movedToTrashResponse ? (
        <>
          <p
            className="small-heading-text"
            style={{ marginBottom: 0, marginTop: 20 }}
          >
            Number of correct reservations:{' '}
            {movedToTrashResponse.numberOfCorrectReservations}
          </p>
          <p className="small-heading-text">
            Number of reservations moved to trash:{' '}
            {movedToTrashResponse.numberOfReservationsMovedToTrash}
          </p>
        </>
      ) : null}
    </div>
  );
};

export default MoveReservationsToTrash;
